import { InsuredDetail, PersonalDetail } from '@/types/InfoState';
import { NationalityResponse } from '@/types/Nationality/NationalityResponse';
import { Identity } from '@/types/Proposal/CalculatePlanPriceRequest';

export const getHomeIdentities = (
  personalDetail: PersonalDetail,
  insuredDetails: InsuredDetail[] = [],
  nationalityList: NationalityResponse[] = [],
): Identity[] =>
  [personalDetail, ...insuredDetails].map((holder) => ({
    idType: holder.idType,
    idNo: holder.idNumber.toString(),
    countryIsoCode: nationalityList.find(
      (x) => x.nationalityId === holder.nationality,
    )?.isO3Code,
  }));
